import { getErrorMessageKeyClock } from "app/shared/services/axios";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { userProfileService } from "../services/auth.service";
import { fetchUserProfileFailure, fetchUserProfileSuccess } from "./actions";
import { FETCH_USER_INFO_REQUEST } from "./actions.type";
import { FetchUserProfileRequest } from "./types";

function* fetchUserProfileSaga(action: FetchUserProfileRequest) {
  try {
    const response: AxiosResponse = yield call(() => userProfileService(action));
    console.log("UserProfile response: ", response);
    if (response.status === 200) {
      yield put(fetchUserProfileSuccess(response.data));
    }
  } catch (e: any | AxiosError) {
    yield put(fetchUserProfileFailure());
    getErrorMessageKeyClock(e, true);
  }
}

function* authSaga() {
  yield all([takeLatest(FETCH_USER_INFO_REQUEST, fetchUserProfileSaga)]);
}

export default authSaga;
